var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useMemo } from "react";
import { StyledCaret, StyledTooltip, StyledContent, caretPosition, caretOffset, caretCenterOffset, } from "./Tooltip.style";
import { ReverseThemeProvider } from "../../theme/ThemeProvider";
// for top, topRight and topLeft
const commonTopPositionStyle = {
    top: caretOffset,
    transform: "translateY(-50%) rotate(45deg)",
};
// for bottom, bottomRight and bottomLeft
const commonBottomPositionStyle = {
    bottom: caretOffset,
    transform: "translateY(50%) rotate(225deg)",
};
// for left, leftTop and leftBottom
const commonLeftPositionStyle = {
    left: caretOffset,
    transform: "translateX(-50%) rotate(-45deg)",
};
// for left, leftTop and leftBottom
const commonRightPositionStyle = {
    right: caretOffset,
    transform: "translateX(50%) rotate(-225deg)",
};
const computeCaretPositionStyle = (pos, firstPosition, middlePosition, lastPosition) => {
    switch (pos) {
        case "topLeft":
            return Object.assign({ left: firstPosition }, commonTopPositionStyle);
        case "top":
            return Object.assign({ left: middlePosition }, commonTopPositionStyle);
        case "topRight":
            return Object.assign({ right: lastPosition }, commonTopPositionStyle);
        case "bottomLeft":
            return Object.assign({ left: firstPosition }, commonBottomPositionStyle);
        case "bottom":
            return Object.assign({ left: middlePosition }, commonBottomPositionStyle);
        case "bottomRight":
            return Object.assign({ right: lastPosition }, commonBottomPositionStyle);
        case "leftTop":
            return Object.assign({ top: lastPosition }, commonLeftPositionStyle);
        case "left":
            return Object.assign({ bottom: middlePosition }, commonLeftPositionStyle);
        case "leftBottom":
            return Object.assign({ bottom: firstPosition }, commonLeftPositionStyle);
        case "rightTop":
            return Object.assign({ top: lastPosition }, commonRightPositionStyle);
        case "right":
            return Object.assign({ bottom: middlePosition }, commonRightPositionStyle);
        case "rightBottom":
            return Object.assign({ bottom: firstPosition }, commonRightPositionStyle);
        default:
            break;
    }
};
const computeCaretPosition = (pos, offset) => {
    // first position from origin: topLeft, bottomLeft, leftBottom, rightBottom
    const firstPosition = `${offset ? caretPosition + offset : caretPosition}px`;
    // last position from origin: topRight, bottomRigth, leftTop, rightTop
    const lastPosition = `${offset ? caretPosition - offset : caretPosition}px`;
    // middle position: top, bottom, left, right
    const middlePositionOffset = offset ? offset - caretCenterOffset : caretCenterOffset;
    const middlePositionSign = !offset || middlePositionOffset < 0 ? "-" : "+";
    const middlePosition = `calc(50% ${middlePositionSign} ${Math.abs(middlePositionOffset)}px)`;
    return computeCaretPositionStyle(pos, firstPosition, middlePosition, lastPosition);
};
export const privateFunctions = { computeCaretPosition };
const Tooltip = (_a) => {
    var { position = "top", variant, spacing = "compact", offset, className, id, children, maxWidth } = _a, rest = __rest(_a, ["position", "variant", "spacing", "offset", "className", "id", "children", "maxWidth"]);
    const dynamicCaretStyles = useMemo(() => privateFunctions.computeCaretPosition(position, offset), [position, offset]);
    return (React.createElement(StyledTooltip, Object.assign({ id: id, variant: variant, className: className, role: "tooltip", maxWidth: maxWidth, position: position }, rest),
        React.createElement(StyledCaret, { style: dynamicCaretStyles, variant: variant }),
        React.createElement(StyledContent, { variant: variant, "$spacing": spacing }, variant ? children : React.createElement(ReverseThemeProvider, null, children))));
};
export default Tooltip;
//# sourceMappingURL=Tooltip.js.map